"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const react_dropzone_1 = __importDefault(require("react-dropzone"));
require("../styles/file-upload.css");
const FileUpload = (props) => (react_1.default.createElement(react_1.default.Fragment, null, !props.disabled && (react_1.default.createElement(react_dropzone_1.default, { disabled: props.uploading, maxSize: props.maxSize, onDrop: (acceptedFiles, fileRejections) => props.onDrop(acceptedFiles, fileRejections) }, ({ getRootProps, getInputProps }) => (react_1.default.createElement(react_1.default.Fragment, null, !props.uploading && (react_1.default.createElement("div", Object.assign({ className: 'file-upload', tabIndex: '0' }, getRootProps()),
    react_1.default.createElement("input", Object.assign({}, getInputProps(), { "data-testid": props.dataTestId })),
    react_1.default.createElement("div", null, props.text)))))))));
exports.FileUpload = FileUpload;
